module.exports = __webpack_public_path__ + "img/landing-title.b7adb5bf.svg";